import React, {Component} from "react";
import {Button, Form, Upload} from "antd";
import {MinusCircleOutlined, PlusOutlined, UploadOutlined} from "@ant-design/icons";

const downLoadFiles={
    "DP":'assets/downLoadFile/DP_BD_Template.xlsx',
}
class EMDCGDisputeRequest extends Component{
    constructor(props) {
        super(props);
        this.state = {
            fileList:[]
        }
    }
    render() {
        return <div className="spaceBox spaceHeaderBox">
            <Form.Item
                label={<label style={{ color: "red" }}>Attention</label>}
                name="attention"
            >
                <Button danger type="text" id={'attachment-attention'}>
                    Pls compress every attachment to 10M below size for faster loading
                </Button>
            </Form.Item>
            <Form.Item
                label={<a href={downLoadFiles.DP} download={downLoadFiles.DP} style={{color:'#dc291e'}}>Template Form</a>}
                name="TemplateForm"
                rules={[{ required: true }]}
            >
                <Upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        listType="text"
                        defaultFileList={[...this.state.fileList]}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
            </Form.Item>
            <Form.List name="template2">
                {(fields, { add, remove }) => (
                    <>
                        <Form.Item
                            className={'addFormBtn'}
                            label="Attachment"
                        >
                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                            </Button>
                            
                        </Form.Item>
                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                            <Form.Item
                                label={<a style={{color:'#dc291e'}}>Template Form</a>}
                                name={[name,"TemplateForm"]}
                                {...restField}
                                fieldKey={[fieldKey, 'TemplateForm']}
                                rules={[{ required: true }]}
                            >
                                <Upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                        listType="text"
                                        defaultFileList={[...this.state.fileList]}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                                <MinusCircleOutlined onClick={() => remove(name)} />
                            </Form.Item>
                        ))}
                    </>
                )}
            </Form.List>
        </div>
    }
}
export default EMDCGDisputeRequest;